import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetContentList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/contents/${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
export const DeleteContent = async function(contentsIds) {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/content`,
            data: contentsIds,
        })
    } catch (e) {
        console.error(e)
    }
}

export const CreateContent = async function(content) {
    try {
        if (content === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: content')
            )

        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/content`,
            data: content,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetContent = async function(contentPublicid) {
    try {
        if (contentPublicid === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: contentPublicid')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/content/${contentPublicid}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const UpdateContent = async function(content) {
    try {
        const { publicId } = content

        if (publicId === undefined)
            return Promise.reject(new Error('Missing required  parameter: id'))

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/content/${publicId}`,
            data: content,
        })
    } catch (e) {
        console.error(e)
    }
}